<soft-page>
  <soft-page-header>
    <div>
      <p class="soft-title">
        {{ '#ABC_ANALYSIS.CONFIGURATION.HEADER_TITLE' | translate }}
      </p>
      <p class="text-sm text-light">
        {{ '#ABC_ANALYSIS.CONFIGURATION.HEADER_SUBTITLE' | translate }}
      </p>
    </div>
  </soft-page-header>
  <label class="soft-label top block mb-2 mt-3">{{
    '#ABC_ANALYSIS.CONFIGURATION.LABEL' | translate
  }}</label>
  <soft-field-ok
    fieldOkName="abcanalyse"
    [(value)]="configuration"
    placeholder="{{ '#ABC_ANALYSIS.CONFIGURATION.PLACEHOLDER' | translate }}"
  ></soft-field-ok>
</soft-page>
